export function RoundDecimal(digits: number) {
    return (target: any, key: string, descriptor: PropertyDescriptor) => {

        const originalMethod = descriptor.value;

        descriptor.value = function (...args : any[]){
            const result = originalMethod.call(this, ...args);

            if(!result)
                return result;

            if(isNaN(result))
                return result;

            return (+result).roundToDigits(digits);
        }
    };
}


// WEBPACK FOOTER //
// ./app/common/decorators/round.decorator.ts